import { Outlet, Link, useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Home, BookOpen, Award, User } from 'lucide-react';
import { api } from '@/lib/api';

export function LearnerLayout() {
  const location = useLocation();

  // Get current user
  const { data: userData } = useQuery({
    queryKey: ['currentUser'],
    queryFn: () => api.getCurrentUser(),
  });

  const currentUser = (userData as any)?.user;

  const navItems = [
    { path: '/learn', label: 'My Courses', icon: Home },
    { path: '/learn/browse', label: 'Browse', icon: BookOpen },
    { path: '/learn/achievements', label: 'Achievements', icon: Award },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center gap-8">
              <Link to="/learn" className="flex items-center gap-2">
                <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center text-white font-bold">
                  T
                </div>
                <span className="text-xl font-semibold">Techtree Learning</span>
              </Link>

              <nav className="flex gap-4">
                {navItems.map((item) => {
                  const Icon = item.icon;
                  const isActive = location.pathname === item.path;

                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                        isActive
                          ? 'bg-primary-50 text-primary-700'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      }`}
                    >
                      <Icon className="w-4 h-4" />
                      {item.label}
                    </Link>
                  );
                })}
              </nav>
            </div>

            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <div className="text-right">
                  <div className="text-sm font-medium">{currentUser?.name || 'Loading...'}</div>
                  <div className="text-xs text-gray-500">{currentUser?.email || ''}</div>
                </div>
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center text-primary-700 font-medium">
                  {currentUser?.name?.[0]?.toUpperCase() || <User className="w-4 h-4" />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main>
        <Outlet />
      </main>
    </div>
  );
}
